import React from 'react';
import { Box, Button, CircularProgress, Slide, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function UnsavedChangesBanner({ visible, onSave, saving }) {
  const { t } = useTranslation();

  return (
    <Slide direction="up" in={visible} mountOnEnter unmountOnExit>
      {/* Outer container: fixed full-width, uses flexbox to center the pill */}
      <Box
        sx={{
          position: 'fixed',
          bottom: { xs: 0, md: 16 },
          left: 0,
          right: 0,
          zIndex: 1300,
          display: 'flex',
          justifyContent: 'center',
          pointerEvents: 'none',
        }}
      >
        <Box
          sx={{
            bgcolor: 'primary.main',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            px: 3,
            py: 1,
            borderRadius: { xs: 0, md: '8px' },
            boxShadow: '0 2px 12px rgba(0,0,0,0.2)',
            width: { xs: '100%', md: 'auto' },
            pointerEvents: 'auto',
          }}
        >
          <Typography variant="body2" sx={{ fontSize: '0.8rem', color: '#ffffff' }}>
            {t('unsavedChanges.bannerMessage')}
          </Typography>
          <Button
            variant="outlined"
            size="small"
            onClick={onSave}
            disabled={saving}
            startIcon={saving ? <CircularProgress size={14} /> : null}
            sx={{
              color: '#ffffff',
              borderColor: 'rgba(255,255,255,0.5)',
              fontSize: '0.75rem',
              py: 0.25,
              '&:hover': { borderColor: '#ffffff', bgcolor: 'rgba(255,255,255,0.1)' },
            }}
          >
            {t('unsavedChanges.bannerSave')}
          </Button>
        </Box>
      </Box>
    </Slide>
  );
}
